import {
  textMediumSemiBold,
  textTinySemiBold,
} from '@hud/web-components/DesignSystem/Typography';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: var(--space-300);

  padding: var(--space-200);
  background-color: var(--black-300);

  border: 1px solid var(--border-color-default);
  border-radius: var(--radius-200);

  svg {
    width: 32px;
    height: 32px;
  }
  .content {
    flex: 1;

    display: flex;
    flex-direction: column;
    gap: var(--space-150);

    align-items: flex-start;

    h3 {
      ${textMediumSemiBold}
      margin: 0
    }
    p {
      ${textTinySemiBold}
      margin: 0;
      max-width: 380px;
    }
  }
`;
